import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-[#F0EBE1] mt-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <Link to="/" className="font-serif text-3xl">
                        ALATI
                    </Link>
                    <p className="mt-6 text-[#4A4A46] leading-relaxed max-w-sm">
                        Traditional handcrafted tallow soap. Made the old way. Trusted today.
                    </p>
                    <p className="mt-8 label">Handmade in Darwin, Australia</p>
                </div>

                <div className="md:col-span-3">
                    <p className="label mb-5">Shop</p>
                    <ul className="space-y-3 text-[15px] text-[#4A4A46]">
                        <li><Link className="alati-link" to="/shop">Handcrafted Tallow Soap</Link></li>
                        <li><Link className="alati-link" to="/shop#artisan-slab-section">Artisan Soap Slabs</Link></li>
                        <li><Link className="alati-link" to="/bundles">Bundle &amp; Save</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="label mb-5">Learn</p>
                    <ul className="space-y-3 text-[15px] text-[#4A4A46]">
                        <li><Link className="alati-link" to="/our-story">Our Story</Link></li>
                        <li><Link className="alati-link" to="/the-process">Traditional Soap</Link></li>
                        <li><Link className="alati-link" to="/ingredients">Ingredients</Link></li>
                        <li><Link className="alati-link" to="/reviews">Reviews</Link></li>
                        <li><Link className="alati-link" to="/contact">Contact</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#E3DED5]">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-[#737562]">
                    <p>&copy; {new Date().getFullYear()} ALATI. Soap made properly.</p>
                    <div className="flex items-center gap-4">
                        <Link className="alati-link" to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
                        <Link className="alati-link" to="/shipping-returns" data-testid="footer-shipping-returns-link">Shipping &amp; Returns</Link>
                        <span className="uppercase tracking-[0.22em]">
                            Apple Pay &middot; Google Pay &middot; Shop Pay
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
